import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CreateOperationRequest, Operation, UpdateOperationConstraintsRequest, UpdateOperationRequest } from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class OperationsService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.bffUrl}/job-orchestrator/operations`;

  getAll(): Observable<Operation[]> {
    return this.http.get<Operation[]>(this.baseUrl);
  }

  getOne(id: string): Observable<Operation> {
    return this.http.get<Operation>(`${this.baseUrl}/${id}`);
  }

  add(request: CreateOperationRequest): Observable<Operation> {
    return this.http.post<Operation>(this.baseUrl, request);
  }

  update(id: string, request: UpdateOperationRequest): Observable<Operation> {
    return this.http.put<Operation>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  updateConstraints(operationId: string, constraints: UpdateOperationConstraintsRequest): Observable<Operation> {
    return this.http.put<Operation>(`${this.baseUrl}/${operationId}/constraints`, constraints);
  }
}
